import { render, staticRenderFns } from "./MantCalenlab.vue?vue&type=template&id=d350b1b4"
import script from "./MantCalenlab.vue?vue&type=script&lang=js"
export * from "./MantCalenlab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports